module.exports = __webpack_public_path__ + "img/civitai-mobile-logo.1db014ba.png";